import { render, staticRenderFns } from "./ssc.vue?vue&type=template&id=f1ff91dc&scoped=true"
import script from "./ssc.vue?vue&type=script&lang=js"
export * from "./ssc.vue?vue&type=script&lang=js"
import style0 from "./ssc.vue?vue&type=style&index=0&id=f1ff91dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ff91dc",
  null
  
)

export default component.exports